import { axios } from '../utils/http'
// 获取影票券 8.0
export const getTicketList = (params) => axios(params, '/fin/voucher/ticketEnable')

// 获取卖品券 8.0
export const getGoodsList = (params) => axios(params, '/fin/voucher/goodsEnable')

// 获取权益券列表-用户 8.0
export const getTradeList = (params) => axios(params, '/fin/voucher/differentTradesEnable')

// 绑定优惠券 8.0
export const bindCoupon = (params) => axios(params, '/fin/voucher/bind')

// 获取影票券使用规则 8.0 公共能图片
export const getTicketUseRule = (params) => axios(params, '/capp/cmt/getCommonFile')

// 获取已使用 8.0
export const getUsedList = (params) => axios(params, '/fin/voucher/used')

// 获取已过期 8.0
export const getOverdueList = (params) => axios(params, '/fin/voucher/overdue')

// 获取订单 8.0
export const queryorderlist = (params) => axios(params, '/trade/order/queryorderlist')

// 订单详情
export const queryMyOrderDetail = (params) => axios(params, '/trade/order/queryMyOrderDetail')

// 获取banner
// export const getAds = (params) => axios(params, '/activity/ads/getAds')

// 获取推荐卖品
// export const getRecommendGoods = (params) => axios(params, '/order/getgoods')

// 获取帮助中心文案
// export const getHelpTxt = (params) => axios(params, '/order/getImage')

// 退款
export const returnOrder = (params) => axios(params, '/trade/order/returnorder')

// 退出登录
export const logout = (params) => axios(params, '/user/logout')

// 获取异业券详情-用户 8.0
export const getUserExchangeDetail = (params) => axios(params, '/fin/voucher/getDifferentTradesDetail')

// 获取异业券详情u+页面 8.0
export const getExchangeDetail = (params) => axios(params, '/fin/voucher/equity/detail')

// 异业商品列表u+页面 8.0
// export const getExchangeList = (params) => axios(params, '/fin/voucher/equity/list')

// 用户领取异业商品接口
export const userGetExchange = (params) => axios(params, '/fin/voucher/bind/equity')

// 获取用户信息
export const getUserInfo = (params) => axios(params, '/user/getUserInfo')

// 获取用户加密手机号
export const getEncryptedPhone = (params) => axios(params, '/user/getEncryptedPhone')





// WEBPACK FOOTER //
// ./src/api/mine.js